import type { Saldo } from "./tipos"

/** Los pagos programados de una semana tal como los da `GET /publico/semana/{token}`. */

export type PagoSemana = {
  /** `GASTO` o `NOMINA`. */
  origen: string
  concepto: string
  tercero: string | null
  monto: string
  divisa: string
  /** «OP-2026-0141 · en aprobación», «NOM-2026-W42 · aprobado» o «por generar». */
  situacion: string
  encaminado: boolean
}

export type DiaSemana = {
  fecha: string
  nombre: string
  total: Saldo[]
  pagos: PagoSemana[]
}

export type Semana = {
  empresa_nombre: string
  empresa_rif: string
  titulo: string
  lunes: string
  domingo: string
  generado_en: string
  expira_en: string
  total_pagos: number
  total: Saldo[]
  gastos: Saldo[]
  nomina: Saldo[]
  por_generar: number
  saldos_por_generar: Saldo[]
  dias: DiaSemana[]
}

/** «Nómina · Jeannifer Rios», o el concepto del gasto tal cual. */
export function nombreDelPago(p: PagoSemana): string {
  return p.origen === "NOMINA" ? `Nómina · ${p.concepto}` : p.concepto
}
